import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { getFilter } from '../configs/dashboard-filters.config';
import { MatExpansionPanel } from '@angular/material/expansion';

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  private filterEvents = new Subject<any>();
  private appliedFiltersState = new BehaviorSubject<object>(null);
  private filtersAppliedDisplay = this.appliedFiltersState.pipe(this.mapFiltersDisplay())
  private lastPageKey = new BehaviorSubject<any>(null)
  private expansionPanel: MatExpansionPanel;
  private applyFilterState: boolean = false;

  constructor() { }

  newEvent(event) {
    this.filterEvents.next(event);
  }

  handleAppliedFiltersState(appliedFilters) {
    let nextFilters;
    if (this.applyFilterState) {
      nextFilters = this.lastAppliedFilters;
      this.applyFilterState = false;
    } else {
      nextFilters = appliedFilters;
    }
    this.appliedFiltersState.next(nextFilters);
  }

  updateLastKeyState(newLastKey: any) {
    this.lastPageKey.next(newLastKey);
  }

  saveFilters() {
    this.applyFilterState = true;
  }

  setPanel(panel: MatExpansionPanel) { 
    this.expansionPanel = panel; 
  }

  togglePanel() { 
    if (!this.expansionPanel) return;
    this.expansionPanel.toggle();
  }

  private mapFiltersDisplay() {
    return map((fils = {}) => {
      const applied = Object.entries(fils)
        .filter(([_, val]) => Boolean(val))
        .map(([key]) => getFilter(key));
      return applied.length ? applied : null;
    })
  }

  get lastKey() {
    return this.lastPageKey.getValue();
  }

  get lastAppliedFilters() {
    return this.appliedFiltersState.getValue();
  }

  get filtersDisplay() {
    return this.filtersAppliedDisplay;
  }

  get events() {
    return this.filterEvents.asObservable();
  }
}